// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1__nj","cls2":"AppsMegaMenu-cls2_iLQ AppsMegaMenu-cls1__nj"};